//angular imports
import { Signal, WritableSignal, computed, signal } from "@angular/core";

export abstract class AbstractFormValueModel
{
    public abstract hasChanged: Signal<boolean>;
    public readOnly: boolean = false;
}

export class FormValueModel<TValueType> extends AbstractFormValueModel
{   
    private originalValue: TValueType|undefined;
    public value: WritableSignal<TValueType> = signal<TValueType>(null);   
    
    public override hasChanged: Signal<boolean> = computed(() => {

        let originalValue = this.originalValue;
        let currentValue = this.value();

        if (!originalValue && !currentValue) return false;        
        if (!originalValue || !currentValue) return true;        

        return originalValue !== currentValue
    });

    public static create<TValueType>(value?: TValueType) {
        let _this = new FormValueModel<TValueType>();
            
        _this.originalValue = value;
        _this.value = signal<TValueType>(value);
    
        return _this;
    }

    public static createReadOnly<TValueType>(value?: TValueType) {
        let _this = FormValueModel.create(value);            
        _this.readOnly = true;    
        return _this;
    }

    public static hasChanges = (values: AbstractFormValueModel[]) =>
        computed(() => values.filter(x=>!!x).some(x => !x.readOnly && x.hasChanged()));
}